import { render, staticRenderFns } from "./WPSelect.vue?vue&type=template&id=60940542"
import script from "./WPSelect.vue?vue&type=script&lang=ts"
export * from "./WPSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports